import { rgb } from "pdf-lib";

export const PDF_TEMPLATE_ID = "8355cac4-fed7-4597-a5cf-672c2f5c7c29";

/**
 * PDF configuration constants
 */
export const CARD_CONFIG = {
  COLUMNS: 4,
  ROWS: 8,
  MAX_CARDS: 28,
  CARD_WIDTH: 134,
  CARD_HEIGHT: 95,
  SPACING_X: 6,
  SPACING_Y: 6,
  START_X: 28,
  START_Y: 960,
};

/** Product name: bottom of card, below QR (PDF y increases upward). */
export const HEADER_CONFIG = {
  /** Baseline of the bottom line of the title from the bottom of the card. */
  BOTTOM_LINE_BASELINE_FROM_BOTTOM: 12,
  LINE_HEIGHT: 9,
  TEXT_SIZE: 7,
  TEXT_COLOR: rgb(0, 0, 0),
  MAX_CHARS_PER_LINE: 24,
  MAX_LINES: 2,
  /** Space between bottom of QR and top of title text. */
  GAP_QR_TO_TITLE: 3,
};

/** QR: centered horizontally; vertical size clamped so it clears the title. */
export const QR_CONFIG = {
  /** Preferred side length; capped by space above the title so it never overlaps text. */
  SIZE: 68,
  TOP_OFFSET_FROM_CARD_TOP: 4,
};

export const CLEAR_AREA = {
  X: 10,
  Y: 300,
  WIDTH: 580,
  HEIGHT: 760,
};

/**
 * Height from the page bottom (PDF y = 0) to paint white and hide the template footer.
 * Matches CLEAR_AREA.Y so the mask stops where the beef grid clear rect begins.
 */
export const POSTER_TEMPLATE_FOOTER_MASK_HEIGHT = CLEAR_AREA.Y;

/**
 * Horizontal inset for poster title (from beef grid left) and QR (from colored strip right).
 * Keeps both elements the same distance from their respective header edges.
 */
export const HEADER_BAND_PADDING_X = 28;

/** Left edge of colored partner header strip (must match beefPdfGenerator layout). */
export const POSTER_HEADER_COLOR_STRIP_X = 309;

/** Main poster title (left column, same band as partner header). */
export const POSTER_MAIN_TITLE = {
  X: CARD_CONFIG.START_X + HEADER_BAND_PADDING_X,
  /** Max width so text does not run into the colored header strip. */
  MAX_WIDTH:
    POSTER_HEADER_COLOR_STRIP_X -
    (CARD_CONFIG.START_X + HEADER_BAND_PADDING_X) -
    12,
  FONT_SIZE_START: 13,
  FONT_SIZE_MIN: 9,
};

// Portion colors mapping
export const PORTION_COLORS = {
  "CHUCK": rgb(0.969, 0.757, 0.271),
  "BRISKET": rgb(0.945, 0.6, 0.671),
  "SHANK": rgb(0.945, 0.6, 0.671),
  "RIB": rgb(0.863, 0.541, 0.38),
  "FLANK": rgb(0.651, 0.604, 0.776),
  "PLATE": rgb(0.651, 0.604, 0.776),
  "SIRLOIN": rgb(0.812, 0.635, 0.792),
  "LOIN": rgb(0.812, 0.635, 0.792),
  "HIP": rgb(0.667, 0.859, 0.804),
  "ROUND": rgb(0.667, 0.859, 0.804),
};
